<elder-single-pane-wrapper>
  <mat-tab-group class="full">
    <mat-tab [label]="'packageTypes.title' | translate" elderTab="packageKinds">
      <app-package-type-browser class="flex" *matTabContent> </app-package-type-browser>
    </mat-tab>
  </mat-tab-group>
</elder-single-pane-wrapper>
